<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ getText(isConsentValid ? processConfig?.consentGoalsGlobalizationConfig :
                processConfig?.globalizationConfig, 'title') | uppercase }}
            </ion-label>
        </ion-item>

        <app-step-description [description]="getText( isConsentValid 
                ? processConfig?.consentGoalsGlobalizationConfig 
                : processConfig?.globalizationConfig,
                 'instructions' )"></app-step-description>

        <ng-container *ngIf="hasRejectGoals()">
            <ion-item lines="none" mode="ios" class="para-content">
                <ion-icon slot="start" class="bp-not-accepted danger"></ion-icon>
                <ion-label class="ion-text-wrap" color="danger">
                    <p>
                        <small>{{ 'goalsInput.hasGoalsRejected' | translate }}</small>
                    </p>
                </ion-label>
                <ion-button slot="end" mode="ios" color="danger" (click)="viewRejectionFeedbacks(goals)">
                    {{ 'goalsInput.seeFeedback' | translate }}
                </ion-button>
            </ion-item>
        </ng-container>

        <ion-card mode="ios" class="card-table-data" *ngIf="processConfig">
            <ion-grid>
                <ion-row>
                    <ion-col size="8">
                        <ion-list class="inputs-progress">
                            <ion-list-header>
                                <ion-label style="font-size: 16px;">
                                    {{ 'goalsInput.totalWeight' | translate }}: {{ getTotalWeight() }}% / 100%
                                </ion-label>
                            </ion-list-header>
                            <ion-progress-bar [value]="getTotalWeight() / 100"></ion-progress-bar>
                        </ion-list>
                    </ion-col>
                    <ion-col size="4">
                        <ion-card-header *ngIf="canAddGoal()" goRight>
                            <ion-button *ngIf="!isConsentValid" mode="ios" color="secondary" id="newGoalButton"
                                (click)="openManageGoalsInputModal()">
                                {{ 'goalsInput.newGoalBtn' | translate }}
                            </ion-button>
                        </ion-card-header>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>

        <ion-card class="table-view" style="margin: 10px 0;" *ngIf="processConfig">
            <app-user-goals-list [goals]="displayedGoals" [goalsInputConfig]="processConfig"
                [isConsentValid]="isConsentValid" [canEditGoals]="canEditGoals(displayedGoals)"
                (edit)="openManageGoalsInputModal($event)" (remove)="confirmDeleteGoal($event)"></app-user-goals-list>
        </ion-card>

        <div class="bottom-buttons ion-text-right">
            <ion-button mode="ios" color="secondary" class="send" id="sendGoalsButton" *ngIf="canEditGoals(goals)"
                (click)="isConsentValid ? submitConsentGoals(goals) : submitGoals(goals)">
                {{ (isConsentValid ? 'goals.consentGoalsBtn' : 'goalsInput.sendGoalsBtn') | translate }}
            </ion-button>
        </div>
    </div>
</ion-content>